import { useTheme } from 'next-themes';
import { useEffect } from 'react';
import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  // Apply width: max-content !important
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      [data-sonner-toast] {
        width: max-content !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          // Default / normal
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',

          // Success toast
          '--success-bg': '#047857',
          '--success-text': 'white',

          // Error toast
          '--error-bg': '#F87171',
          '--error-text': 'white',

          // Warning toast
          '--warning-bg': '#FBBF24',
          '--warning-text': 'black',

          // Shared styles
          '--toast-radius': '8px',
          '--toast-box-shadow': '0 4px 12px -1px rgba(0, 0, 0, 0.10)',
          '--toast-font-family': 'Geist, var(--font-font-sans), sans-serif',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
